'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _initTranslateProp = require('./init-translate-prop');

var _initTranslateProp2 = _interopRequireDefault(_initTranslateProp);

var _constants = require('../constants/constants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var getDataOrDefault = function getDataOrDefault(arr, value, name) {
  return arr.indexOf(value) > -1 ? value : _constants.propsDefault[name];
};

var getScale = function getScale(scale, timing) {
  return ['small', 'medium'].indexOf(timing) > -1 ? 0.75 : 0.9;
};

var getDelay = function getDelay(value) {

  var delay = (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object' ? value : { enter: value, exit: value };

  return {
    enter: delay.enter ? delay.enter : 0,
    exit: delay.exit ? delay.exit : 0
  };
};

var propsMap = {
  timing: function timing(value, name) {
    return getDataOrDefault(_constants.timings, value, name);
  },
  sequence: function sequence(value, name) {
    return value && getDataOrDefault(_constants.sequences, value, name);
  },
  children: function children(_children) {
    return _react2.default.Children.toArray(_children);
  },
  opacity: function opacity(_opacity) {
    return !!_opacity;
  },
  scale: function scale(_scale, _, _ref) {
    var timing = _ref.timing;
    return !!_scale && getScale(_scale, timing);
  },
  height: function height(_height) {
    return !!_height && _height;
  },
  width: function width(_width) {
    return !!_width && _width;
  },
  translate: function translate(_translate) {
    return _translate && (0, _initTranslateProp2.default)(_translate);
  },
  delay: function delay(value) {
    return !!value && getDelay(value);
  },
  childStyle: function childStyle(value) {
    return !!value && value;
  },
  childClassName: function childClassName(value) {
    return !!value && value;
  },
  show: function show(value, _, _ref2) {
    var debug = _ref2.debug;
    return !!debug || value;
  }
};

var getPropData = function getPropData(name, value, props) {
  var getPropMethod = propsMap[name];
  return getPropMethod && getPropMethod(value, name, props);
};

var getData = function getData(props) {
  return Object.keys(propsMap).reduce(function (data, propName) {
    return _extends(_defineProperty({}, propName, getPropData(propName, props[propName], props)), data);
  }, {});
};

var formatProps = function formatProps(props) {
  return getData(props);
};

exports.default = formatProps;